import React, {useEffect, useCallback} from "react";

import config from "../../../config";
import RestRequest from "../../../tool/RestRequest";

const FindCity = ({models, actions}) => {

    let timer;

    let handleTypingText = (e) => {
        let value = e.target.value;

        if (value.length <= 0) {
            return false;
        }

        if (timer) {
            clearTimeout(timer);
        }

        timer = setTimeout(() => {

            RestRequest.all(`${config.restCity}?filter[NAME_RU]=${value}`).then(data => {
                if (data.data.length > 0) {
                    actions.setModels(data.data);
                }
            });

        }, 400);
    };

    useEffect(() => {
        const btn = document.querySelector('.city-find-form-input');
        btn.addEventListener('keyup', handleTypingText);
    }, []);

    return <>
        <form className="city-find-form" method="POST">
            <input className="city-find-form-input" name="city" type="text" placeholder="Найти свой город"/>
        </form>
    </>;
};

export default FindCity;